import { useMutation } from '@tanstack/react-query'

import { EServerPath } from '~/models/api'
import { TConversation } from '~/models/features'
import HttpService from '~/services/http'
import pathBuilder from '~/utils/api'

type TParams = {
  conversationId: string
  agentId: string
}

const useEndChatbotConversation = () => {
  return useMutation({
    mutationFn: ({ conversationId, agentId }: TParams) => {
      return HttpService.post<TConversation>({
        path: pathBuilder(EServerPath.endChatConversation, { conversationId }),
        payload: { agentId },
      })
    },
  })
}

export default useEndChatbotConversation
